import { createBrowserHistory } from 'history';
import { combineReducers, createStore } from 'redux';
import { connectRouter } from 'connected-react-router';
import * as reducers from './reducers';

export const history = createBrowserHistory();

export const store = createStore( combineReducers({ ...reducers, router: connectRouter(history) }));
